import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import proImage from "assets/image/book_dflt_prd_item.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./slide.scss";
import Image from "components/image";

type IProps = {
  rmImgList: any;
};

export default function Slider({ rmImgList }: IProps) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="swiper-container">
      <div>
        <button ref={prevRef} className="prev-img" />
        <button ref={nextRef} className="next-img" />
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper: any) => {
          // 수동으로 버튼 DOM 참조 설정
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        onSwiper={(swiper) => {
          // 💡 수동으로 Navigation 초기화 필요
          if (
            swiper.params.navigation &&
            typeof swiper.navigation.init === "function"
          ) {
            swiper.navigation.init();
            swiper.navigation.update();
          }
        }}
      >
        {rmImgList.length !== 0 &&
          rmImgList.map((item: any, index: number) => {
            return (
              <SwiperSlide key={index}>
                <Image
                  src={item.thumImgPhUrl || item.resImgPhUrl}
                  alt="객실 이미지"
                />
                {/* <img
                  src={item.thumImgPhUrl || item.resImgPhUrl}
                  alt="객실이미지 슬라이드"
                  // loading="lazy"
                  onError={(e) => {
                    if (e.type === "error") {
                      e.currentTarget.src = proImage;
                    }
                  }}
                /> */}
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
}
